const initMap = () => {
  const { Map, Marker } = google.maps;
  const geocoder = new google.maps.Geocoder();

  // Geocoding
  geocodeAddress(geocoder, map);
};

const geocodeAddress = (geocoder, map) => {
  geocoder.geocode({ address: address }, (results, status) => {
    if (status === "OK") {

      const lat = results[0].geometry.location.lat();
      const lng = results[0].geometry.location.lng();

      map = new google.maps.Map(document.getElementById("map"), {
        center: { lat, lng },
        zoom: 11,
        gestureHandling: 'none', 
      });

      // Définir le style de la carte
      const mapStyles = [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#FCFCF8"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off" 
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "landscape",
          "stylers": [
            {
              "color": "#FCFCF8"
            }
          ]
        },
        {
          "featureType": "water",
          "stylers": [
            {
              "color": "#4EC3D7"
            }
          ]
        },
        {
          "featureType": "road",
          "stylers": [
            {
              "color": "#EAE8DF"
            }
          ]
        },
      ];

      // Appliquer le style à la carte
      map.setOptions({ styles: mapStyles });
      
       // Créer un marqueur personnalisé avec le SVG
       const svgIcon = {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg width="100%" height="100%" viewBox="0 0 27 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-28,-20.8555)"><path d="M40.02,52.112L39.628,51.846C37.665,50.472 35.842,48.909 34.183,47.18C31.268,44.125 28,39.544 28,34.138C28,27.488 33.394,20.856 41.276,20.856C49.158,20.856 54.553,27.488 54.553,34.14C54.553,39.546 51.285,44.127 48.37,47.178C46.711,48.907 44.887,50.47 42.925,51.844C42.759,51.96 42.628,52.048 42.533,52.11C42.118,52.386 41.695,52.647 41.276,52.913C40.858,52.647 40.435,52.386 40.02,52.112Z" style="fill:rgb(0,133,172);fill-rule:nonzero;"/><path d="M40.5,35.365C42.013,37.877 43.942,38.785 46.681,37.341C48.011,36.603 49.227,35.861 50.164,34.596C51.99,32.176 50.166,28.62 47.013,29.5C45.892,29.783 44.965,30.3 44.044,30.91C43.224,31.465 42.313,32.061 41.513,32.638C41.343,32.761 41.172,32.884 41.001,33.008C40.5,32.308 39.959,31.633 39.275,31.039C38.629,30.479 37.761,30.03 36.836,30.102C35.394,30.182 34.107,31.44 34.163,32.889C34.218,34.436 34.918,35.773 35.731,37.037C35.537,37.201 35.345,37.366 35.154,37.533C32.813,39.36 32.004,40.271 31.946,40.338C31.854,40.444 31.866,40.604 31.971,40.695C32.077,40.787 32.238,40.776 32.33,40.671C32.344,40.654 33.165,39.734 35.545,37.88C35.713,37.761 35.881,37.641 36.051,37.524C36.326,37.936 36.607,38.343 36.872,38.748C39.43,42.804 42.686,41.998 45.872,39.873C46.253,39.619 48.019,38.383 48.511,38.028C49.163,37.557 49.8,37.066 50.42,36.553C50.527,36.464 50.542,36.304 50.453,36.196C50.362,36.088 50.203,36.074 50.094,36.163C49.294,36.827 48.461,37.454 47.608,38.049C46.206,38.894 44.775,39.728 43.249,40.284C41.338,40.992 39.665,40.53 38.502,38.844C38.197,38.366 37.687,37.604 37.188,36.753C38.164,36.104 39.153,35.474 40.149,34.856C40.278,35.048 40.396,35.223 40.5,35.365ZM36.552,32.368C37.631,31.713 39.362,33.737 39.583,34.039C38.655,34.719 37.734,35.411 36.834,36.129C36.831,36.124 36.829,36.119 36.825,36.114L36.836,36.114C36.836,36.114 35.432,33.047 36.552,32.368ZM44.715,32.062C46.127,31.388 47.285,31.803 47.608,32.454C47.961,33.164 48.237,34.251 46.568,35.419C46.341,35.552 46.113,35.679 45.892,35.795C43.93,36.823 43.061,36.097 41.952,34.381C41.849,34.232 41.747,34.083 41.645,33.933C42.394,33.475 43.143,33.018 43.888,32.56C44.154,32.397 44.431,32.228 44.715,32.062Z" style="fill:white;fill-rule:nonzero;"/><path d="M41.453,30.994C42.287,30.994 42.964,30.319 42.964,29.487C42.964,28.655 42.287,27.98 41.453,27.98C40.619,27.98 39.943,28.655 39.943,29.487C39.943,30.319 40.619,30.994 41.453,30.994Z" style="fill:white;fill-rule:nonzero;"/></g></svg>'),
        scaledSize: new google.maps.Size(27, 33),
        anchor: new google.maps.Point(13, 33),
      };

      new google.maps.Marker({
        map: map,
        position: { lat, lng },
        icon: svgIcon,  // Utilisation du SVG comme icône

      });

    } else {
      console.error("Geocode failed due to: " + status);
    }
  });
};

// Initmap globally available
window.initMap = initMap;
